import { FC } from 'react';
// Redux
import { useAppSelector } from 'hooks/useStore';
import { selectQuiz } from 'store/quiz/quizSelectors';
// i18next
import { Trans, useTranslation } from 'react-i18next';

const PoweredBy:FC = () => {
  const { t } = useTranslation();

  const quiz = useAppSelector(selectQuiz);

  if (quiz.whiteLabeling) return null;
  return (
    <div className="my-2">
      <h3 className="font-semibold text-center text-primary">
        <Trans
          t={t}
          components={{
            span: <span className="font-bold" style={{ fontFamily: 'Montserrat' }} />,
            span2: <span style={{ color: '#ff9100' }} />,
          }}
          i18nKey="labels.poweredBy"
        />
      </h3>
    </div>
  );
}

export default PoweredBy;
